// ═══════════════════════════════════════════════════════════════════════════
// umbralesPublicidad — umbrales de negocio del dashboard de Publicidad,
// configurables POR EMPRESA (jul 2026, pedido Mariano).
// ───────────────────────────────────────────────────────────────────────────
// Mismo patrón que slaAtencion.js (umbral SLA de Preguntas): los valores viven
// en el doc de la empresa (`empresas/{id}.umbralesPublicidad.ml`) y se editan
// inline desde el propio dashboard — sin deploy, sin tocar functions.
//
// Campos:
//   pisoClicksSinVenta   : clicks de publicidad SIN venta que se toleran antes
//                          de listar el ad en "Ads con gasto sin venta" /
//                          "Ads con productos que generan pérdida".
//                          Default 30 (reporte wRYrhXebQdUfZuQ8NGRQ).
//   umbralAcosGeneradores: fracción (0.05 = 5%). Un generador indirecto con
//                          ACOS TOTAL (directo + indirecto) ≤ este umbral se
//                          MANTIENE (queda excluido de las secciones de pausa).
//                          null = automático → usa el ACOS promedio de la cuenta.
// ═══════════════════════════════════════════════════════════════════════════

import { doc, updateDoc, serverTimestamp } from 'firebase/firestore'
import { db } from './firebase'

export const PISO_CLICKS_DEFAULT = 30

/** Piso de clicks sin venta (default 30). */
export function getPisoClicks(empresa) {
  const v = empresa?.umbralesPublicidad?.ml?.pisoClicksSinVenta
  return (typeof v === 'number' && v >= 0) ? v : PISO_CLICKS_DEFAULT
}

/** Umbral de ACOS total para mantener generadores indirectos. null = auto (ACOS promedio). */
export function getUmbralAcosGeneradores(empresa) {
  const v = empresa?.umbralesPublicidad?.ml?.umbralAcosGeneradores
  return (typeof v === 'number' && v > 0) ? v : null
}

/**
 * Persiste un umbral en el doc de la empresa.
 * @param {string} empresaId
 * @param {'pisoClicksSinVenta'|'umbralAcosGeneradores'} campo
 * @param {number|null} valor — null borra el override (vuelve al default/auto)
 */
export async function setUmbralPublicidad(empresaId, campo, valor) {
  if (!empresaId) throw new Error('setUmbralPublicidad: falta empresaId')
  await updateDoc(doc(db, 'empresas', empresaId), {
    [`umbralesPublicidad.ml.${campo}`]: valor,
    actualizadoEn: serverTimestamp(),
  })
}
